var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6491 8.99995L17.6579 1.9909C18.114 1.53499 18.114 0.797843 17.6579 0.341933C17.202 -0.113978 16.4649 -0.113978 16.009 0.341933L8.9999 7.35099L1.99106 0.341933C1.53493 -0.113978 0.798003 -0.113978 0.342093 0.341933C-0.114031 0.797843 -0.114031 1.53499 0.342093 1.9909L7.35094 8.99995L0.342093 16.009C-0.114031 16.4649 -0.114031 17.2021 0.342093 17.658C0.5693 17.8854 0.868044 17.9996 1.16657 17.9996C1.4651 17.9996 1.76364 17.8854 1.99106 17.658L8.9999 10.6489L16.009 17.658C16.2364 17.8854 16.5349 17.9996 16.8334 17.9996C17.132 17.9996 17.4305 17.8854 17.6579 17.658C18.114 17.2021 18.114 16.4649 17.6579 16.009L10.6491 8.99995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.a3a8ddb4d03625392c552fee578d62a1.svg";
export { ForwardRef as ReactComponent };